import { useRouter } from 'next/router'
import queryString from 'query-string'
import { LINKAREER_BASE_URL } from 'utils/config'

export const useHandleLogin = () => {
  const router = useRouter()

  const handleOnLogin = () => {
    const next = `${LINKAREER_BASE_URL}${router.pathname}`
    router.push(`/login?${queryString.stringify({ next })}`)
  }

  return { handleOnLogin }
}
